import React from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import Dashboard from '@material-ui/icons/Dashboard';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import {makeStyles} from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ForumIcon from '@material-ui/icons/Forum';
import MessageIcon from '@material-ui/icons/Message';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import Footer from './Footer';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PeopleIcon from '@material-ui/icons/People';
import KeyboardIcon from '@material-ui/icons/Keyboard';
const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
	list: {
		height: '100%',
		width: drawerWidth,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
}));

const MobileDrawer = ({open, auth, closeDrawer}) => {
	const title = process.env.REACT_APP_TITLE;

	const classes = useStyles();

	const location = useLocation();

	return (
		<aside className={'drawer'}>
			<Drawer open={open} onClose={closeDrawer}>
				<AppBar position='static' color={'primary'}>
					<Toolbar>
						<IconButton
							edge='start'
							className={classes.menuButton}
							color='inherit'
							aria-label='Close drawer'
							onClick={closeDrawer}
						>
							<MenuIcon />
						</IconButton>
						<Typography variant='h5' noWrap>
							<Link underline='none' component={RouterLink} to='/' color={'inherit'}>
								{title}
							</Link>
						</Typography>
					</Toolbar>
				</AppBar>
				<div className={classes.list}>
					{auth.isAuth && (
						<>
							<List>
								<ListItem
									button
									onClick={closeDrawer}
									selected={location.pathname === '/'}
									component={RouterLink}
									to={'/'}
								>
									<ListItemIcon>
										<HomeIcon />
									</ListItemIcon>
									<ListItemText primary={'Home'} />
								</ListItem>
								<ListItem
									button
									onClick={closeDrawer}
									selected={location.pathname === '/chat'}
									component={RouterLink}
									to={'/chat'}
								>
									<ListItemIcon>
										<ForumIcon />
									</ListItemIcon>
									<ListItemText primary={'Chat'} />
								</ListItem>
								<ListItem
									button
									onClick={closeDrawer}
									selected={location.pathname === '/door'}
									component={RouterLink}
									to={'/door'}
								>
									<ListItemIcon>
										<MeetingRoomIcon />
									</ListItemIcon>
									<ListItemText primary={'Door'} />
								</ListItem>
								<ListItem
									button
									onClick={closeDrawer}
									selected={location.pathname === '/keypad'}
									component={RouterLink}
									to={'/keypad'}
								>
									<ListItemIcon>
										<KeyboardIcon />
									</ListItemIcon>
									<ListItemText primary={'Keypad Code'} />
								</ListItem>
								<ListItem
									button
									selected={location.pathname === '/users'}
									component={RouterLink}
									to={'/users'}
									onClick={closeDrawer}
								>
									<ListItemIcon>
										<PeopleIcon />
									</ListItemIcon>
									<ListItemText primary={'Members'} />
								</ListItem>
							</List>

							<Divider />

							<List>
								<ListItem
									button
									component={RouterLink}
									selected={location.pathname === '/article/add'}
									to={'/article/add'}
									onClick={closeDrawer}
								>
									<ListItemIcon>
										<AddBoxIcon />
									</ListItemIcon>
									<ListItemText primary={'Add article'} />
								</ListItem>
							</List>

							<ListItem
								button
								selected={location.pathname === '/messages'}
								component={RouterLink}
								to={'/messages'}
								onClick={closeDrawer}
							>
								<ListItemIcon>
									<MessageIcon />
								</ListItemIcon>
								<ListItemText primary={'Messages'} />
							</ListItem>
						</>
					)}
					{auth.isAdmin && (
						<>
							<Divider />
							<List>
								<ListItem
									button
									component={RouterLink}
									selected={location.pathname === '/admin/dashboard'}
									to={'/admin/dashboard'}
									onClick={closeDrawer}
								>
									<ListItemIcon>
										<Dashboard />
									</ListItemIcon>
									<ListItemText primary={'Dashboard'} />
								</ListItem>
								<ListItem
									button
									selected={location.pathname === '/admin/users'}
									component={RouterLink}
									to={'/admin/users'}
									onClick={closeDrawer}
								>
									<ListItemIcon>
										<PeopleIcon />
									</ListItemIcon>
									<ListItemText primary={'All Users'} />
								</ListItem>
								<ListItem
									button
									selected={location.pathname === '/admin/addUser'}
									component={RouterLink}
									to={'/admin/addUser'}
									onClick={closeDrawer}
								>
									<ListItemIcon>
										<PersonAddIcon />
									</ListItemIcon>
									<ListItemText primary={'Add User'} />
								</ListItem>
							</List>
						</>
					)}
				</div>
				<Footer />
			</Drawer>
		</aside>
	);
};

MobileDrawer.propTypes = {
	open: PropTypes.bool,
	auth: PropTypes.shape({
		isAuth: PropTypes.bool,
		isAdmin: PropTypes.bool,
	}),
	closeDrawer: PropTypes.func,
};

export default MobileDrawer;
